import React from 'react';
import styled from 'styled-components';
import * as Button from '@commoncomponents/frontend-components/dist/components/Buttons';
import { breakpoints } from '@commoncomponents/frontend-components/dist/styled';
import ActivationCodeInput from '../ActivationCodeInput';
import Warning from '../Warning';
const BottomButtons = ({ translations, onCancelButtonClick, onMainButtonClick, shouldMainButtonBeDisabled = false, shouldShowCodeInput, isMobileView, onCodeInputChange, codeErrorMessage, newPlanInfoMessage, isProcessing = false, showUserSelectionRequiredWarning = false, planChangeWarning, }) => (React.createElement(BottomButtonsWrapper, { shouldDisplayWarning: showUserSelectionRequiredWarning || Boolean(planChangeWarning), isMobileView: isMobileView },
    showUserSelectionRequiredWarning && (React.createElement(Warning, { message: translations.userSelectionRequiredWarning })),
    planChangeWarning && React.createElement(Warning, { message: planChangeWarning }),
    React.createElement(Wrapper, { shouldShowCodeInput: shouldShowCodeInput, isMobileView: isMobileView },
        shouldShowCodeInput && (React.createElement(ActivationCodeInput, { label: translations.enterCodeInputLabel, onChange: onCodeInputChange, errorMessage: codeErrorMessage, infoMessage: newPlanInfoMessage })),
        React.createElement(ButtonsWrapper, { shouldShowCodeInput: shouldShowCodeInput },
            React.createElement(Button.GhostRounded, { onClick: onCancelButtonClick, label: translations.cancelButtonText }),
            React.createElement(Button.PrimaryRounded, { onClick: onMainButtonClick, label: planChangeWarning
                    ? translations.activateAnywayButtonText
                    : translations.mainButtonText, disabled: shouldMainButtonBeDisabled, isProcessing: !shouldMainButtonBeDisabled && isProcessing, fullWidth: Boolean(planChangeWarning) }))),
    React.createElement(ScrollbarGradient, { isMobileView: isMobileView })));
const ScrollbarGradient = styled.div `
  position: absolute;
  height: ${({ isMobileView }) => (isMobileView ? `16px` : `24px`)};
  top: -19px;
  left: 0;
  right: 0;
  background: #fff;
  filter: blur(40px);
  transform: matrix(1, 0, 0, -1, 0, 0);
`;
const BottomButtonsWrapper = styled.div `
  display: flex;
  flex-direction: ${({ shouldDisplayWarning }) => shouldDisplayWarning ? 'column' : 'row'};
  position: relative;
  ${({ isMobileView }) => !isMobileView && `min-height: 72px;`}
`;
const Wrapper = styled.div `
  align-items: ${({ isMobileView }) => isMobileView ? 'flex-end' : 'flex-start'};
  display: flex;
  flex-direction: ${({ isMobileView }) => (isMobileView ? 'column' : 'row')};
  justify-content: ${({ shouldShowCodeInput }) => shouldShowCodeInput ? 'space-between' : 'flex-end'};
  height: 100%;
  width: 100%;

  & button:last-child {
    margin-left: 20px;
    min-width: 104px;
  }

  .activation-code-input {
    margin: 12px 8px 16px 24px;
    width: 264px;
  }
`;
const ButtonsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  padding: ${({ shouldShowCodeInput }) => shouldShowCodeInput ? '34px 24px 16px 0' : '19px 24px 16px 0'};
  @media ${breakpoints.md} {
    padding: 16px 16px 16px 0;
  }
`;
export default BottomButtons;
